import React from 'react';
import { Box, Typography } from '@mui/material';
import { TransactionsListPage } from 'src/solventpay/transactions/views/TransactionsListPage';

/**
 * Transactions Tab Component
 * Embeds the TransactionsListPage with super admin context
 */
export function TransactionsTab({ dateRange }) {
  // Convert dashboard date range format (strings) to Date objects if provided
  // Memoize to prevent unnecessary re-renders
  const externalDateRange = React.useMemo(() => {
    return dateRange && dateRange.start_date && dateRange.end_date
      ? [new Date(dateRange.start_date), new Date(dateRange.end_date)]
      : null;
  }, [dateRange?.start_date, dateRange?.end_date]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        All Transactions
      </Typography>
      
      <Box sx={{ mt: 2 }}>
        <TransactionsListPage 
          isSuperAdmin={true} 
          externalDateRange={externalDateRange}
          hideDatePicker={true}
        />
      </Box>
    </Box>
  );
}
